import "./TeamDrawer.scss";
import "../data-kit/DataKitDrawer.scss";
import {ReactNode, useEffect} from "react";
import {useDrawerDismiss} from "../data-kit/useDrawerDismiss";

interface TeamDrawerProps {
  label: string;
  className?: string;
  onClose: () => void;
  children: (dismiss: () => void) => ReactNode;
}

export function TeamDrawer({label, className, onClose, children}: TeamDrawerProps) {
  const {closing, dismiss} = useDrawerDismiss();
  const close = () => dismiss(onClose);

  useEffect(() => {
    const onKeyDown = (ev: KeyboardEvent) => {
      if (ev.key === "Escape") close();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  });

  return (
    <>
      <div className={`data-kit-drawer-scrim${closing ? " closing" : ""}`} onClick={close}/>
      <aside role="dialog" aria-label={label} className={`team-drawer${className ? ` ${className}` : ""}${closing ? " closing" : ""}`}>
        {children(close)}
      </aside>
    </>
  );
}
